(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/pickers/next-race-buttons.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/pickers/next-race-buttons.js');

'use strict';

const {
  fetchNextHighFive,
  fetchRaceNext
} = svs.racing.raceService;
const {
  ReactButton,
  ReactIcon
} = svs.ui;
const {
  useState,
  useEffect,
  useMemo
} = React;
const {
  navigation
} = svs.racing;
const {
  useNavigationActions
} = svs.racing.navigation;
const {
  raceDefaultGameType
} = svs.racing.common.util;
const {
  gameTypes,
  systemTypes
} = svs.racing.common.constants;
const NextRaceButtons = _ref => {
  let {
    raceSummaries,
    systemType
  } = _ref;
  const {
    toRace
  } = useNavigationActions();
  const navState = navigation.useNavigationState();
  const [nextHighFiveRace, setNextHighFiveRace] = useState(undefined);
  const [nextRace, setNextRace] = useState(undefined);
  const [disableNextHighFive, setDisableNextHighFive] = useState(false);
  const [disableNextRace, setDisableNextRace] = useState(false);
  const [loadingHighFive, setLoadingHighFive] = useState(true);
  const [loadingNextRace, setLoadingNextRace] = useState(true);
  const fetchNextUpcomingRace = () => {
    setLoadingNextRace(true);
    fetchRaceNext((err, race) => {
      if (err) {
        setDisableNextRace(true);
      } else {
        setDisableNextRace(false);
        setNextRace(race);
      }
      setLoadingNextRace(false);
    });
  };
  const goToRace = (race, gameType) => {
    toRace(race.meeting.formattedDate, race.meeting.track.urlName, race.raceNumber, gameType ? gameType : raceDefaultGameType(race));
  };
  const currRaceIsNextRace = useMemo(() => {
    if (raceSummaries) {
      const result = raceSummaries.find(raceSummary => raceSummary.meeting.formattedDate === navState.day && raceSummary.meeting.track.urlName === navState.trackName && raceSummary.raceNumber.toString() === navState.raceNumber);
      if (!result || !nextRace) {
        return false;
      }
      return result.raceId === nextRace.raceId;
    }
  }, [navState.day, navState.trackName, navState.raceNumber, nextRace]);
  useEffect(() => {
    if (!nextHighFiveRace) {
      setLoadingHighFive(true);
      fetchNextHighFive((err, race) => {
        if (err) {
          setDisableNextHighFive(true);
        } else {
          setDisableNextHighFive(false);
          setNextHighFiveRace(race);
        }
        setLoadingHighFive(false);
      });
    }
    if (!nextRace) {
      fetchNextUpcomingRace();
    }
  }, []);
  const isLoading = loadingHighFive || loadingNextRace;
  const isHighFive = navState.gameType === gameTypes.TOPP5 && systemType !== systemTypes.RESULT;
  return React.createElement("div", {
    className: "padding-h-1 next-race-racing-buttons-holder"
  }, React.createElement(ReactButton, {
    className: "btn next-race-racing-buttons",
    disabled: disableNextHighFive || isHighFive || isLoading,
    onClick: () => goToRace(nextHighFiveRace, 'topp5'),
    size: 100,
    thin: true,
    transparent: true
  }, "N\xE4sta High Five", React.createElement(ReactIcon, {
    color: "fc-racing",
    icon: "shortcut",
    size: "100"
  })), React.createElement(ReactButton, {
    className: "btn next-race-racing-buttons",
    disabled: disableNextRace || currRaceIsNextRace || isLoading,
    onClick: () => goToRace(nextRace),
    size: 100,
    thin: true,
    transparent: true
  }, "N\xE4sta lopp", React.createElement(ReactIcon, {
    color: "fc-racing",
    icon: "shortcut",
    size: "100"
  })));
};
svs.racing_game.components.play.NextRaceButtons = NextRaceButtons;

 })(window);